<template>
  <table v-if="mode == 'individual'" class="sf-table tw-mx-auto tw-text-left">
    <tbody>
      <tr v-for="(p, k) in purchaseData.products" :key="k">
        <td class="first-letter:tw-uppercase">
          {{ p.label || getLabel(p.name) }}
        </td>
        <td class="tw-text-right">
          {{
            $filters.longDateFormat(p.period.start, false)
          }}
          to
          {{ $filters.longDateFormat(p.period.end, false) }}
        </td>
        <td class="tw-text-right">
          {{ $filters.renderMoney(p.total) }}
        </td>
      </tr>
      <template v-for="(d, k) in purchaseData.discounts" :key="k">
        <tr v-if="d.total > 0">
          <td colspan="2">
            {{ getLabel(d.name) }}
          </td>
          <td class="tw-text-right">
            {{ $filters.renderMoney(d.total) }}
          </td>
        </tr>
      </template>
      <tr class="tw-font-bold">
        <td>Total</td>
        <td></td>
        <td class="tw-text-right">
          {{ $filters.renderMoney(purchaseData.total) }}
        </td>
      </tr>
    </tbody>
  </table>
  <table v-else class="sf-table tw-mx-auto tw-text-left">
    <tbody>
      <tr v-if="schoolReference">
        <td>Your Reference</td>
        <td class="tw-text-right" colspan="2">
          {{ schoolReference }}
        </td>
      </tr>
      <template v-for="(item, k) in purchaseData.products" :key="k">
        <tr v-if="item.count + item.total > 0">
          <td>
            {{ getLabel(item.name) }}
          </td>
          <td class="tw-text-right">
            {{ item.count }} x {{ $filters.renderMoney(item.cost) }}
          </td>
          <td class="tw-text-right">
            {{ $filters.renderMoney(item.total) }}
          </td>
        </tr>
      </template>
      <template v-for="(item, k) in purchaseData.discounts" :key="k">
        <tr v-if="item.count + item.total > 0">
          <td>
            {{ getLabel(item.name) }}
          </td>
          <td class="tw-text-right">
            {{ item.count }} x {{ $filters.renderMoney(item.discount) }}
          </td>
          <td class="tw-text-right">
            {{ $filters.renderMoney(item.total) }}
          </td>
        </tr>
      </template>
      <tr v-if="purchaseData.tax" class="tw-font-bold">
        <td>Total cost before VAT</td>
        <td></td>
        <td class="tw-text-right">
          {{ $filters.renderMoney(purchaseData.subtotal) }}
        </td>
      </tr>
      <tr v-if="purchaseData.tax">
        <td>
          {{ purchaseData.tax.name }}
        </td>
        <td class="tw-text-right">
          {{ $filters.renderPercent(purchaseData.tax.value) }}
        </td>
        <td class="tw-text-right">
          {{ $filters.renderMoney(purchaseData.taxTotal) }}
        </td>
      </tr>
      <tr class="tw-font-bold">
        <td>Total</td>
        <td></td>
        <td class="tw-text-right">
          {{ $filters.renderMoney(purchaseData.total) }}
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script lang="ts">
import { isMathsAvailable } from "@/state/appState";
import { SfPurchaseType, SfStorePurchaseData } from "@/types/generalTypes";
import { defineComponent, PropType } from "vue";

export default defineComponent({
  props: {
    mode: { type: String as PropType<SfPurchaseType> },
    schoolReference: { type: String },
    purchaseData: {
      type: Object as PropType<SfStorePurchaseData>,
      required: true,
    },
  },
  computed: {
    mathsAvailable() {
      if(this.mode == 'individual') {
        return isMathsAvailable('individual', 'store');
      }
      return isMathsAvailable('school', 'store');
    }
  },
  methods: {
    getLabel(name: string) {
      switch (name) {
        case "classSpelling":
          return "Spelling classes";
        case "classMaths":
          return "Maths classes";
        case "spellingMathsClassCombo":
          return "Spelling + Maths class discount";
        case "spelling":
          return "Spelling Subscription";
        case "maths":
          return "Maths Subscription";
        case "mathsws":
          return "Maths Worksheets Subscription";
        case "individualFullCombo":
          return "Full Subcription Discount";
      }
      return name;
    },
  },
});
</script>
